import { Injectable } from '@angular/core';
import { MenuService } from './menu.service';
import { PanelItem } from '../models/menu/panel-item.model';
import { Upsell } from '../models/menu/upsell.model';
import { ItemType } from '../models/menu/item-type.enum';
import { ImageAlternativeType } from '../models/menu/image-alternative-type.enum';
import { Picture } from '../models/menu/picture.model';
import { SizePrice } from '../models/menu/size-price.model';
import { Utils } from '../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class MenuWrapperService extends MenuService {

  public convertUpsellToPanelItem(upsell: Upsell): PanelItem {
    const panelItem = new PanelItem().deserialize({
      label: upsell.orderableItem!.label,
      name: upsell.orderableItem!.label || upsell.orderableItem!.name,
      labelSymbol: upsell.orderableItem!.labelSymbol,
      type: ItemType.ITEM,
      links: upsell.orderableItem!.links,
      sizePrices: upsell.size
        ? [upsell.size]
        : upsell.orderableItem!.sizePrices,
      description: upsell.orderableItem!.description,
      showFullSizeCalories: upsell.orderableItem!.showFullSizeCalories,
    });

    if (upsell.imageUrl) {
      const picture = {
        src: upsell.imageUrl,
        srcset: upsell.imageUrl,
        type: ImageAlternativeType.ORIGINAL,
      } as Picture;
      panelItem.pictures = [picture];
    }

    return panelItem;
  }

  public getDefaultSizePrice(sizePrices: SizePrice[]): SizePrice {
    return Utils.getDefaultSizePrice(sizePrices) ?? sizePrices[0];
  }

  override getPanelItemPictureSrc(
    panelItem: PanelItem,
    type?: ImageAlternativeType
  ): string | undefined {
    return (
      super.getPanelItemPictureSrc(panelItem, type) || undefined
    );
  }
}
